import { Receipt } from "components";
import { Discount } from "types";
import { FeeRow, formatFeeRow } from "./formatFeeRow";

interface FeesTableProps {
  booking: number;
  professional: number;
  transaction: number;
  total: number;
  discount: Discount;
  size?: number;
}

const FeesTable: React.FC<FeesTableProps> = ({
  professional,
  booking,
  transaction,
  total,
  discount,
  size,
}) => {
  const { label, percentage } = discount;
  const deduction = total * (percentage / 100);
  const balance = total - deduction;

  const fees: FeeRow[] = [
    ["Professional Fee", professional],
    ["Booking Fee (with VAT)", booking],
    ["Transaction Fee (with VAT)", transaction],
  ];

  const subtotal: FeeRow[] = [
    ["Subtotal", total],
    [label, deduction * -1],
  ];

  const final: FeeRow[] = [["Total", balance]];

  return (
    <Receipt
      size={size}
      labelStyle={{ flex: 1 }}
      items={[
        fees.map((fee) => formatFeeRow(fee)),
        subtotal.map((fee) => formatFeeRow(fee)),
        final.map((fee) => formatFeeRow(fee, "₱")),
      ]}
    />
  );
};

export type { Discount };
export default FeesTable;
